import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

// Keep old mobile element links working through the same live editor as desktop.
const CategoriesAndElements = () => {
    const { id } = useParams()
    return <Navigate replace to={`/editor/${id}`} state={{ production: true }} />
}

export default CategoriesAndElements
